import type React from 'react';
import { resolveProductUrl } from '@podus/utils';

/* ── Brand SVG icons matching the auth app (apps/auth/src/assets/) ── */

/** Podus AI brand logo — simplified P mark in orange */
export function PodusLogoIcon({ className = '' }: { className?: string }) {
    return (
        <svg viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M5.5 1C3.01 1 1 3.01 1 5.5V12.5C1 14.99 3.01 17 5.5 17H8.5C8.78 17 9 16.78 9 16.5V10C9 9.45 9.45 9 10 9H13.5C15.99 9 18 6.99 18 4.5C18 2.01 15.99 0 13.5 0H6.5C5.95 0 5.5 0.45 5.5 1Z"
                fill="#FF6600"
            />
            <circle cx="14" cy="4.5" r="2" fill="white" />
        </svg>
    );
}

/** Appointment icon from auth — dual checkmark/abstract shapes (appointmenticon.svg) */
function AppointmentIcon({ className = '' }: { className?: string }) {
    return (
        <svg viewBox="0 0 57 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.66501 22.8349L10.9614 28.0798C12.363 29.4678 14.3657 29.5729 15.905 28.5158C16.453 28.1395 17.0239 27.4952 17.6978 26.8468C19.076 25.5206 20.7125 23.9186 21.7254 22.9085C19.897 23.8487 18.1294 23.7002 16.5836 22.2167L11.1622 17.0959C7.50763 13.6439 2.52867 18.5587 5.1195 22.2991C5.26614 22.5109 5.46806 22.6399 5.66501 22.8349Z" fill="#FF6720"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M27.3818 11.9495L27.3819 11.9495C28.8857 13.4644 28.8672 15.9249 27.3409 17.4174L16.4333 28.0831C15.0283 29.4569 12.8739 29.6003 11.3236 28.3931L5.11914 22.2993C7.20881 24.2519 9.4592 23.9919 11.2711 22.2706L11.2711 22.275L21.8725 11.9088C23.3988 10.4163 25.878 10.4346 27.3818 11.9495Z" fill="#424547" fillOpacity="0.690196"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M29.7766 17.1798L35.0604 11.9474C36.462 10.5595 38.4647 10.4543 40.0039 11.5114C40.5519 11.8877 41.1229 12.532 41.7968 13.1804C43.1749 14.5066 44.8115 16.1086 45.8243 17.1187C43.996 16.1785 42.2284 16.327 40.6826 17.8105L35.2612 22.9313C33.4222 24.6684 31.469 26.3805 29.6032 28.1104C28.0096 29.5879 25.488 29.5027 23.9993 27.9212C22.5107 26.3397 22.5965 23.837 24.19 22.3595L29.3115 17.611C29.4028 17.5095 29.5071 17.4241 29.6145 17.3301L29.7766 17.1798Z" fill="#FF6720"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M51.4814 28.0779L51.4815 28.0779C52.9853 26.563 52.9668 24.1025 51.4405 22.61L40.5329 11.9443C39.1279 10.5705 36.9736 10.4271 35.4233 11.6343L29.2188 17.7281C31.3084 15.7755 33.5588 16.0355 35.3707 17.7568L35.3707 17.7524L45.9721 28.1186C47.4985 29.6111 49.9776 29.5928 51.4814 28.0779Z" fill="#424547" fillOpacity="0.690196"/>
        </svg>
    );
}

/** Contract icon from auth — document with lines and side tab (contracticon.svg) */
function ContractIcon({ className = '' }: { className?: string }) {
    return (
        <svg viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M25.625 5.125C26.9842 5.125 28.2879 5.66495 29.249 6.62598C30.2101 7.5871 30.75 8.89077 30.75 10.25V18.792H35.875C36.328 18.792 36.7626 18.9717 37.083 19.292C37.4034 19.6124 37.584 20.0469 37.584 20.5V30.75C37.584 31.5922 37.3443 32.8186 36.5791 33.8828C35.7472 35.0376 34.3807 35.8749 32.459 35.875H8.54199C6.61841 35.875 5.25213 35.0359 4.42188 33.8828C3.77623 32.9649 3.42543 31.8722 3.41699 30.75V10.25C3.41699 8.89077 3.95684 7.5871 4.91797 6.62598C5.87909 5.66485 7.18276 5.125 8.54199 5.125H25.625ZM32.459 22.208C32.0059 22.208 31.5714 22.3886 31.251 22.709C30.9306 23.0294 30.75 23.4639 30.75 23.917V30.75C30.75 31.2031 30.9306 31.6376 31.251 31.958C31.5713 32.2783 32.006 32.458 32.459 32.458C32.9119 32.4579 33.3467 32.2783 33.667 31.958C33.9873 31.6376 34.167 31.203 34.167 30.75V23.917C34.167 23.4641 33.9872 23.0293 33.667 22.709C33.3467 22.3887 32.9119 22.2081 32.459 22.208ZM9.1416 28.2568C8.37691 28.257 7.75704 28.8769 7.75684 29.6416C7.75684 30.4065 8.37678 31.0271 9.1416 31.0273H25.21C25.9748 31.0271 26.5947 30.4065 26.5947 29.6416C26.5945 28.8769 25.9746 28.2571 25.21 28.2568H9.1416ZM9.1416 22.1621C8.37691 22.1623 7.75704 22.7822 7.75684 23.5469C7.75684 24.3117 8.37678 24.9324 9.1416 24.9326H25.21C25.9748 24.9324 26.5947 24.3117 26.5947 23.5469C26.5945 22.7822 25.9746 22.1623 25.21 22.1621H9.1416ZM9.1416 16.0674C8.37691 16.0676 7.75704 16.6875 7.75684 17.4521C7.75684 18.217 8.37678 18.8377 9.1416 18.8379H25.21C25.9748 18.8377 26.5947 18.217 26.5947 17.4521C26.5945 16.6875 25.9746 16.0676 25.21 16.0674H9.1416ZM9.1416 9.97363C8.37678 9.97383 7.75684 10.5935 7.75684 11.3584C7.7569 12.1232 8.37682 12.743 9.1416 12.7432H25.21C25.9747 12.7429 26.5947 12.1232 26.5947 11.3584C26.5947 10.5936 25.9748 9.97386 25.21 9.97363H9.1416Z" fill="#FF6720"/>
        </svg>
    );
}

/** Checker icon from auth — diamond shield with eye (checkericon.svg) */
function CheckerIcon({ className = '' }: { className?: string }) {
    return (
        <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path fillRule="evenodd" clipRule="evenodd" d="M7.16699 10.7788L18.3659 4.73031C20.9523 3.67075 23.5539 3.55863 26.1789 4.73031L37.7422 10.7788C36.8709 11.5525 35.9778 11.986 35.0685 12.1552C33.624 12.4239 32.3112 12.0754 31.0656 11.3745L25.5017 8.24536C24.4573 7.90198 23.4879 7.73459 22.5896 7.73075C21.6443 7.7266 20.7769 7.90294 19.9807 8.24536L14.5561 11.1976C13.2198 11.9253 12.297 12.2747 10.6958 12.1383C9.46213 12.0335 8.28833 11.5649 7.16699 10.7788Z" fill="#FF6720"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M38.9648 13.6567L38.815 26.3098C38.4838 29.0673 37.3121 31.3753 35.0001 33.0768L24.0355 40.1387C23.7806 39.0063 23.8356 38.021 24.1307 37.1508C24.5998 35.7686 25.5473 34.8017 26.7717 34.065L32.2399 30.7739C33.0519 30.037 33.6724 29.2791 34.1144 28.5029C34.5796 27.6862 34.8481 26.8489 34.9358 25.992L34.9886 19.8522C35.0013 18.3394 35.1446 17.3696 36.0463 16.0493C36.7409 15.0319 37.726 14.2441 38.9648 13.6567Z" fill="#FF6720"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M6.12695 13.6562L6.27676 26.3093C6.60799 29.0668 7.77968 31.3748 10.0917 33.0763L21.0562 40.1382C21.3111 39.0058 21.2561 38.0206 20.9611 37.1504C20.492 35.7681 19.5445 34.8012 18.3201 34.0646L12.8518 30.7734C12.0399 30.0365 11.4194 29.2786 10.9774 28.5025C10.5122 27.6858 10.2437 26.8484 10.156 25.9915L10.1031 19.8517C10.0905 18.3389 9.9472 17.3691 9.04542 16.0488C8.3509 15.0315 7.36571 14.2436 6.12695 13.6562Z" fill="#FF6720"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M22.0941 14.5098C23.6757 14.5098 25.1353 15.0285 26.31 15.9035C26.0854 15.8587 25.853 15.8351 25.6152 15.8351C23.6773 15.8351 22.1063 17.3943 22.1063 19.3176C22.1063 21.2405 23.6773 22.7997 25.6152 22.7997C27.2408 22.7997 28.6084 21.7018 29.0065 20.2126C29.0831 20.6256 29.1237 21.0515 29.1237 21.4865C29.1237 25.3395 25.9763 28.4633 22.0941 28.4633C18.2119 28.4633 15.0645 25.3395 15.0645 21.4865C15.0645 17.6335 18.2119 14.5098 22.0941 14.5098Z" fill="#E40A0A"/>
            <path d="M30.325 16.154C31.2402 16.154 31.9821 15.4177 31.9821 14.5094C31.9821 13.6011 31.2402 12.8647 30.325 12.8647C29.4099 12.8647 28.668 13.6011 28.668 14.5094C28.668 15.4177 29.4099 16.154 30.325 16.154Z" fill="#852F08"/>
        </svg>
    );
}

/** IRIS eye/visibility icon */
function IrisIcon({ className = '' }: { className?: string }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
            <path d="M12 6.5c3.79 0 7.17 2.13 8.82 5.5-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5-2.5-1.12-2.5-2.5 1.12-2.5 2.5-2.5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5 4.5-2.02 4.5-4.5-2.02-4.5-4.5-4.5z" />
        </svg>
    );
}

/**
 * 3x3 dot grid icon used for the "All Podus Tools" link.
 */
export function GridDotsIcon({ className = '' }: { className?: string }) {
    return (
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <circle cx="2" cy="2" r="2" fill="#151515" />
            <circle cx="9" cy="2" r="2" fill="#151515" />
            <circle cx="16" cy="2" r="2" fill="#151515" />
            <circle cx="2" cy="8" r="2" fill="#151515" />
            <circle cx="9" cy="8" r="2" fill="#151515" />
            <circle cx="16" cy="8" r="2" fill="#151515" />
            <circle cx="2" cy="14" r="2" fill="#151515" />
            <circle cx="9" cy="14" r="2" fill="#151515" />
            <circle cx="16" cy="14" r="2" fill="#151515" />
        </svg>
    );
}

export type AppId =
    | 'podus-ai'
    | 'podus-legal'
    | 'podus-appointments'
    | 'podus-checker'
    | 'iris'
    | 'podus-legal-aid';

export interface PodusProduct {
    id: AppId;
    title: string;
    description: string;
    /** Icon component — rendered at runtime by the consuming app's React version */
    Icon: React.ComponentType<{ className?: string }>;
    iconClassName: string;
    href: string;
}

/**
 * Default list of all Podus products.
 * Icons match the auth app (apps/auth/src/assets/).
 * URLs match the production domains used in the auth app (apps/auth/src/pages/dashboard/Products.tsx).
 */
export const DEFAULT_PRODUCTS: PodusProduct[] = [
    {
        id: 'podus-ai',
        title: 'Legal Assistant',
        description: 'Ask legal questions, get instant AI-powered answers now.',
        Icon: PodusLogoIcon,
        iconClassName: 'w-[22px] h-[18px]',
        href: resolveProductUrl('https://podus.ai'),
    },
    {
        id: 'podus-appointments',
        title: 'Connect With A Lawyer',
        description: 'Book appointments with verified legal professionals.',
        Icon: AppointmentIcon,
        iconClassName: 'w-6 h-5',
        href: resolveProductUrl('https://appointment.podus.ai'),
    },
    {
        id: 'podus-legal',
        title: 'Contract Management',
        description: 'Create, review, and manage legal contracts with ease.',
        Icon: ContractIcon,
        iconClassName: 'w-6 h-6',
        href: resolveProductUrl('https://contract.podus.ai'),
    },
    {
        id: 'podus-legal-aid',
        title: 'Podus Aid',
        description: 'Legal aid access made simple, fast, and fair.',
        Icon: ContractIcon,
        iconClassName: 'w-6 h-6',
        href: resolveProductUrl('https://podus.org'),
    },
    {
        id: 'podus-checker',
        title: 'Podus Checker',
        description: 'Background investigation and compliance checking platform.',
        Icon: CheckerIcon,
        iconClassName: 'w-6 h-6',
        href: resolveProductUrl('https://checker.podus.ai'),
    },
    {
        id: 'iris',
        title: 'IRIS',
        description: 'Intimate relationship indicators screening and assessment.',
        Icon: IrisIcon,
        iconClassName: 'w-6 h-6 text-[#151515]',
        href: resolveProductUrl('https://ipvp.citizensgavel.org'),
    },
];

/** Get all products except the specified current app. */
export function getOtherProducts(currentApp: AppId, products: PodusProduct[] = DEFAULT_PRODUCTS): PodusProduct[] {
    return products.filter((p) => p.id !== currentApp);
}
